import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

@Injectable()
export class AiPriceBudgetSuggesterService {
  baseHref = `${environment.apiUrl}/ai-price-budget-suggester`;

  constructor(private http: HttpClient) {}

  // Add interface
  getPriceSuggesterEntity(taskId: number): Observable<any> {
    const url = `${this.baseHref}/${taskId}`;
    return this.http.get<any>(url);
  }
}
